export default __webpack_public_path__ + "static/media/img_fukidashi_red.e1b64acb.svg";